import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LangService } from 'src/app/service/lang.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  private subscriptions: Subscription;
  activeState: boolean[] = [true, false, false,];
  dir: string = '';

  constructor(public translate: TranslateService, public langser: LangService) {
    this.subscriptions = this.langser.getData().subscribe(value => {
      this.setValue(value);
    });
  }

  ngOnInit(): void {
    const lang = this.langser.getLang();
    this.setValue(lang);
  }

  setValue(lang: string) {
    this.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }

  toggle(index: number) {
    this.activeState[index] = !this.activeState[index];
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
